module.exports = __webpack_public_path__ + "static/media/website-white-bg-trimmed.fc90816a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/website-white-bg-trimmed.svg
// module id = 810
// module chunks = 49